import React from "react";
import { Badge, Group, Stack, Text } from "@mantine/core";
import Employee from "../../employees/services/model/Employee";

type MatchedEmployeePayslipBoxProps = {
  data: Employee;
  status: string;
};

const MatchedEmployeePayslipBox: React.FC<MatchedEmployeePayslipBoxProps> = ({
  data,
  status,
}) => (
  <div
    style={{
      height: "324px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "stretch",
      gap: "8px",
      padding: "24px",
      borderRadius: "4px",
      border: "solid 1px var(--grey-grey-50)",
      backgroundColor: "var(--background-background)",
    }}
  >
    <Group
      position="apart"
      style={{
        alignItems: "flex-start",
      }}
    >
      <Stack>
        <Group direction="column" spacing="sm">
          <Text
            style={{
              height: "18px",
              alignSelf: "stretch",
              flexGrow: 0,
              fontFamily: "Inter",
              fontSize: "12px",
              fontWeight: "normal",
              fontStretch: "normal",
              fontStyle: "normal",
              lineHeight: 1.5,
              letterSpacing: "0.16px",
              textAlign: "left",
              color: "var(--grey-grey-70)",
            }}
          >
            Name
          </Text>
          <Text
            style={{
              height: "20px",
              flexGrow: 0,
              fontFamily: "Inter",
              fontSize: "14px",
              fontWeight: 500,
              fontStretch: "normal",
              fontStyle: "normal",
              lineHeight: 1.43,
              letterSpacing: "0.16px",
              textAlign: "left",
              color: "var(--grey-grey-80)",
            }}
          >
            {`${data.first_name} ${data.last_name}`}
          </Text>
        </Group>
        <Group direction="column" spacing="sm">
          <Text
            style={{
              height: "18px",
              alignSelf: "stretch",
              flexGrow: 0,
              fontFamily: "Inter",
              fontSize: "12px",
              fontWeight: "normal",
              fontStretch: "normal",
              fontStyle: "normal",
              lineHeight: 1.5,
              letterSpacing: "0.16px",
              textAlign: "left",
              color: "var(--grey-grey-70)",
            }}
          >
            ID Number
          </Text>
          <Text
            style={{
              width: "150px",
              height: "16px",
              flexGrow: 0,
              fontFamily: "Inter",
              fontSize: "14px",
              fontWeight: "bold",
              fontStretch: "normal",
              fontStyle: "normal",
              lineHeight: "normal",
              letterSpacing: "0.16px",
              textAlign: "left",
              color: "var(--grey-grey-80)",
            }}
          >
            {data.id_number}
          </Text>
        </Group>
        <Group direction="column" spacing="sm">
          <Text
            style={{
              height: "18px",
              alignSelf: "stretch",
              flexGrow: 0,
              fontFamily: "Inter",
              fontSize: "12px",
              fontWeight: "normal",
              fontStretch: "normal",
              fontStyle: "normal",
              lineHeight: 1.5,
              letterSpacing: "0.16px",
              textAlign: "left",
              color: "var(--grey-grey-70)",
            }}
          >
            Employee Number
          </Text>
          <Text
            style={{
              width: "150px",
              height: "16px",
              flexGrow: 0,
              fontFamily: "Inter",
              fontSize: "14px",
              fontWeight: "bold",
              fontStretch: "normal",
              fontStyle: "normal",
              lineHeight: "normal",
              letterSpacing: "0.16px",
              textAlign: "left",
              color: "var(--grey-grey-80)",
            }}
          >
            {data.employee_no}
          </Text>
        </Group>
      </Stack>

      {Object.is("Unmatched", status) ? (
        <Badge
          variant="outline"
          size="lg"
          styles={{
            root: {
              borderColor: "#ff922b",
              color: "#ff922b",
            },
            inner: {
              borderColor: "#ff922b",
              color: "#ff922b",
            },
          }}
        >
          {status}
        </Badge>
      ) : (
        <Badge
          variant="outline"
          size="lg"
          styles={{
            root: {
              borderColor: "#94d82d",
              color: "#94d82d",
            },
            inner: {
              borderColor: "#94d82d",
              color: "#94d82d",
            },
          }}
        >
          {status}
        </Badge>
      )}
    </Group>
  </div>
);

export default MatchedEmployeePayslipBox;
